module.exports = __webpack_public_path__ + "static/media/blue-back.94b5bd73.svg";